module.exports = __webpack_public_path__ + "img/red-x.d3fcb78d.svg";